const doc = [({"ja":({"labelHotelWaitingList":({"date":"宿泊日", "email":"メールアドレス", "hotelRoomId":"部屋タイプ", "hotelPlanId":"プラン"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;